import PropTypes from 'prop-types';
import React, { Component } from 'react';

export class FileDownload extends Component {
  static propTypes = {
    actionPath: PropTypes.string.isRequired,
    onDownloadComplete: PropTypes.func.isRequired,
  };

  componentDidMount() {
    // timeout to give browsers a bit of time to respond to the iframe
    setTimeout(() => { this.props.onDownloadComplete(); }, 5000);
  }

  render() {
    const { actionPath } = this.props;

    return (
      <iframe src={actionPath} className="hidden" height="1" width="1" title="Downloaded File" />
    );
  }
}